/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMedicalPayments32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={35}
      height={35}
      fill='none'
      viewBox='0 0 35 35'
      {...props}
    >
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M13.29 6.016H6.562v26.25h22.421V6.016h-6.726'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M13.29 6.016H6.562v26.25h22.421V6.016h-6.726'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M21.875 5.468a2.733 2.733 0 00-2.733-2.734h-3.284a2.733 2.733 0 00-2.733 2.734v2.188h8.75V5.468z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M12.578 15.313h10.39M17.773 20.234v-9.843M10.39 24.063h9.844M10.39 27.89h5.47'
      />
    </svg>
  );
}

export default SvgMedicalPayments32;
